module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-e3817bef8a1b740de107d36826151fd4.png";